import { JsonObject, JsonProperty } from 'json-ts-mapper';

@JsonObject
export class ModeCamion {
  constructor (
    codeCamion?: string,
    libelle?: string
  ) {
    this.codeCamion = codeCamion as any;
    this.libelle = libelle as any;
  }

  @JsonProperty(String)
  codeCamion: string;

  @JsonProperty(String)
  libelle: string;
}
